import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPlayButton56(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="play">
            <g filter="url(#filter0_b_469_8124)">
                <circle
                    cx="28"
                    cy="28"
                    r="24"
                    fill={props.fill || 'currentColor'}
                    fillOpacity="0.5"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.4116 26.1794C41.9748 26.8899 41.9748 29.1103 40.4116 29.8208L21.8282 38.2678C20.504 38.8697 19.0006 37.9017 19.0006 36.4471L19.0006 19.5531C19.0006 18.0985 20.504 17.1305 21.8282 17.7324L40.4116 26.1794ZM21.0006 36.4471L39.584 28.0001L21.0006 19.5531L21.0006 36.4471Z"
                fill={props.foregroundcolor || 'black'}
            />
            <defs>
                <filter
                    id="filter0_b_469_8124"
                    x="0"
                    y="0"
                    width="56"
                    height="56"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="2"
                    />
                    <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_469_8124"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_469_8124"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

export function IconPlayButton96(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="96"
            height="96"
            viewBox="0 0 96 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="play">
            <g filter="url(#filter0_b_1744_56290)">
                <rect
                    width="96"
                    height="96"
                    rx="48"
                    fill={props.fill || 'currentColor'}
                    fillOpacity="0.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M72.8222 44.3585C75.9486 45.7796 75.9486 50.2203 72.8222 51.6414L35.6554 68.5354C33.007 69.7392 30.0002 67.8031 30.0002 64.8939L30.0002 31.1059C30.0002 28.1968 33.007 26.2607 35.6554 27.4645L72.8222 44.3585ZM34.0002 64.8939L71.167 47.9999L34.0002 31.1059L34.0002 64.8939Z"
                    fill={props.foregroundcolor || 'black'}
                />
            </g>
            <defs>
                <filter
                    id="filter0_b_1744_56290"
                    x="-4"
                    y="-4"
                    width="104"
                    height="104"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="2"
                    />
                    <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_1744_56290"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_1744_56290"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

export function IconPlayButton132(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="132"
            height="132"
            viewBox="0 0 132 132"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="play">
            <g filter="url(#filter0_b_6769_113866)">
                <circle
                    cx="65.8492"
                    cy="65.8502"
                    r="56.4429"
                    fill={props.fill || 'currentColor'}
                    fillOpacity="0.5"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M95.0436 61.5685C98.7198 63.2395 98.7199 68.4614 95.0436 70.1324L51.3393 89.998C48.2251 91.4136 44.6894 89.1369 44.6894 85.716L44.6894 45.9849C44.6894 42.564 48.2251 40.2874 51.3393 41.7029L95.0436 61.5685ZM49.393 85.716L93.0972 65.8505L49.393 45.9849L49.393 85.716Z"
                fill={props.foregroundcolor || 'black'}
            />
            <defs>
                <filter
                    id="filter0_b_6769_113866"
                    x="-0.000907898"
                    y="6.86646e-05"
                    width="131.701"
                    height="131.7"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="4.70358"
                    />
                    <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_6769_113866"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_6769_113866"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
